module.exports = __webpack_public_path__ + "static/media/Crossover1.1950f1a0.jpg";